export default "__VITE_ASSET__DpA_nzMZ__"